export default {
      id: "code-usage",
      viewBox: "0 0 48 48",
      url: "assets/" + "sprite.svg#code-usage",
      toString: function () {
        return this.url;
      }
    }